import {
	CompassWidgetAppearanceType,
	CompassWidgetConfig,
} from 'areas/metrics/widgets/Compass/config';
import { ColorDescriptionType } from 'components/HighchartsWrapper';
import { i18n } from 'core/localization';

import { Editor } from './editor';
import CompassWidget from './index';
import { legendDefaultValue } from 'areas/metrics/components/MetricLegendSelect/constants';
import { LabelPosition, LabelVisibility } from 'areas/metrics/components/LabelOptionsEditor/types';
import { tooltipDefaultValue } from 'areas/metrics/components/MetricTooltipSelect/constants';
import { WidgetDescription } from 'controls/designer/features/widgets/types';

export function getWidgetDescription(): WidgetDescription<CompassWidgetConfig> {
	return {
		form: Editor,
		defaultConfig: {
			type: 'metric-compass',
			title: i18n('Radial Gauge'),
			metric: {
				metricId: null,
			},
			minValue: 0,
			maxValue: 360,
			appearance: {
				type: CompassWidgetAppearanceType.Compass,
				ticksCount: 12,
				paneBackgroundColor: {
					type: ColorDescriptionType.Gradient,
					startColor: '#E6E6E6',
					finishColor: '#FFFFFF',
				},
				axisColor: '#000000',
				indicatorColor: '#000000',
				invertDial: false,
				legendTemplate: [...legendDefaultValue],
				tooltipTemplate: ['<Metric name>', '<Value and unit>'],
				labels: {
					direction: {
						size: 14,
						color: '#000000',
						position: LabelPosition.Inside,
						visibility: LabelVisibility.Visible,
					},
					value: {
						size: 12,
						color: '#000000',
						position: LabelPosition.Middle,
						visibility: LabelVisibility.Visible,
					},
					legend: {
						size: 12,
						color: '#000000',
						position: LabelPosition.Bottom,
						visibility: LabelVisibility.Visible,
					},
					tick: {
						size: 12,
						color: '#000000',
						position: LabelPosition.Outside,
						visibility: LabelVisibility.Visible,
					},
				},
			},
		},
		containerStyle: () => {
			return {
				transparent: true,
				noBorder: true,
			};
		},

		preProcessConfig: (config) => {
			const legacyAppearance = config.appearance as any;
			if (legacyAppearance.anglesLabelPosition) {
				// @ts-ignore
				config.appearance.labels = {};

				config.appearance.labels.tick = {
					size: 12,
					color: legacyAppearance.fontColor,
					position:
						legacyAppearance.anglesLabelPosition != 'none'
							? legacyAppearance.anglesLabelPosition
							: LabelPosition.Outside,
					visibility:
						legacyAppearance.anglesLabelPosition != 'none'
							? LabelVisibility.Visible
							: LabelVisibility.Hidden,
				};

				delete legacyAppearance.anglesLabelPosition;
			}

			if (legacyAppearance.directionLabelPosition) {
				config.appearance.labels.direction = {
					size: 14,
					color: legacyAppearance.fontColor,
					position:
						legacyAppearance.directionLabelPosition != 'none'
							? legacyAppearance.directionLabelPosition
							: LabelPosition.Outside,
					visibility:
						legacyAppearance.directionLabelPosition != 'none'
							? LabelVisibility.Visible
							: LabelVisibility.Hidden,
				};

				delete legacyAppearance.directionLabelPosition;
			}

			if (legacyAppearance.fontColor) {
				config.appearance.labels.value = {
					size: 12,
					color: legacyAppearance.fontColor,
					visibility: LabelVisibility.Visible,
					position: LabelPosition.Middle,
				};

				delete legacyAppearance.fontColor;
			}

			if (legacyAppearance.metricNameColor) {
				config.appearance.labels.legend = {
					size: 12,
					color: legacyAppearance.metricNameColor,
					position:
						legacyAppearance.metricNamePosition != 'none'
							? legacyAppearance.metricNamePosition
							: LabelPosition.Outside,
					visibility:
						legacyAppearance.metricNamePosition != 'none'
							? LabelVisibility.Visible
							: LabelVisibility.Hidden,
				};

				delete legacyAppearance.metricNameColor;
				delete legacyAppearance.metricNamePosition;
			}

			if (legacyAppearance.fontColor) {
				delete legacyAppearance.fontColor;
			}

			if (!config.appearance.legendTemplate) {
				config.appearance.legendTemplate = [...legendDefaultValue];
			}

			if (!config.appearance.tooltipTemplate) {
				config.appearance.tooltipTemplate = [...tooltipDefaultValue];
			}

			return config;
		},
		widget: CompassWidget,
		fullTitle: i18n('Radial Gauge'),
	};
}
